import React, {useEffect, useState} from "react";
import { Editor } from '@tinymce/tinymce-react';
/*import "ace-builds/src-noconflict/mode-html"
import "ace-builds/src-noconflict/mode-css"
import "ace-builds/src-noconflict/theme-monokai"*/
import AceEditor from "react-ace"
import {withRouter} from "react-router-dom";

import "ace-builds/src-noconflict/mode-html"
import "ace-builds/src-noconflict/theme-monokai"

const EditorComponent = props => {
    const [value, setValue] = useState("")
    useEffect(() => {
        if(props.location.state){
            setValue(props.location.state.data)
        } else {
            let text = JSON.parse(localStorage.getItem("text"))
            if(text) setValue(text)
        }
    },[])
    return <div>
        <button onClick={() => {
            let text = JSON.parse(localStorage.getItem("text"))
            if(text) setValue(text)
        }}>localstorage</button>
        <MainEditor
            value={value}
            onChange={e => setValue(e)}
            onSaveContent={() => localStorage.setItem("text", JSON.stringify(value))}
            height={800}
        />
        <AceEditor
            value={value}
            onChange={e => setValue(e)}
            width="100%"
            theme="monokai"
            mode="html"
            style={{ marginTop: "50px" }}
        />
    </div>
}

export default withRouter(EditorComponent)

const MainEditor = ({ style, className, required, value, tooltip, label, valid, errorMessage, onChange, height = 300, disabled, onSaveContent }) => {
    return <div style={ style }  className={className}>
        {
            (label) ? <label data-tooltip={tooltip} style={{display: "block"}}>
                {(tooltip) ? <div className="squerTooltipe"/> : null} {label} {(required) ? <span style={{color: "red"}}>*</span> : null}</label> : null
        }
        <Editor
            value={value}
            apiKey='4eyj4tfa2r63xnd6kuaey29f1n2u1f5fmbszpaw26rydzx2q'
            init={{
                height: height,
                plugins: [
                    ' preview paste searchreplace autolink autosave save directionality visualblocks ' +
                    'visualchars fullscreen image link media codesample table charmap hr pagebreak nonbreaking ' +
                    'anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap emoticons'
                ],
                menubar: 'file edit view insert format tools table help',
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect ' +
                    '| alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak ' +
                    '| charmap emoticons | fullscreen  preview print | insertfile image media template link anchor codesample',
                toolbar_sticky: false,
                language: 'ru'
            }}
            style={{ border: (!valid) ? "1px solid red" : '' }}
            onEditorChange={onChange}
            disabled={disabled}
            onSaveContent={onSaveContent}
        />
    </div>
}